import { Injectable, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { DataService } from './data.service';
import { ToastrService } from './toastr.service';

@Injectable()
export class LandingPageService {
    unifiedRedemption: any;
    model: any = {};

    constructor(private _dataService: DataService,
        private _authenticationService: AuthenticationService,
        private _toastrService: ToastrService,
        private _router: Router) { }

    setParams(params) {
        this.unifiedRedemption = params;
        if (this.unifiedRedemption.keyStatus == 'available' && (this.unifiedRedemption.keyType == 'license_key' || this.unifiedRedemption.keyType == 'master_code_key')) {
            this.model.license_key = this.unifiedRedemption.key;
            this.redeemLicenseKey();

        } else if (this.unifiedRedemption.keyStatus == 'available' && this.unifiedRedemption.keyType == 'isbn') {
            this.model.isbn_key = this.unifiedRedemption.key;
            this.redeemISBN();
        }
    }

    redeemLicenseKey() {
        const url = '/auth/redeemLicenseKey';

        const body = {
            'licenseKey': this.model.license_key,
            'userID': this._authenticationService.getUserID()
        };
        this._dataService.post(url, body)
            .subscribe(
                (data: { data: any, response: string, response_message: Array<any> }) => {
                    if (data.response === 'success') {
                        (<any>window).gtag('event', 'Click', {
                            'event_category': 'Button Clicked',
                            'event_label': `License Key Redeem Button for ${this.model.license_key}`
                        });

                        this._toastrService.typeCustomSuccess(data.response_message);
                        this._router.navigate(['home']);

                    }
                },
                (error) => {
                    if (error.error.err_message === 'ER_DUP_ENTRY') {
                        this._toastrService.typeCustomError("This account already has a Master Code associated with it.");
                    } else {
                        this._toastrService.typeCustomError(error.error.response_message || error.status_text);
                    }
                    this._router.navigate(['home']);
                });
    }

    redeemISBN() {
        const body = {
            'questionAns': this.unifiedRedemption.questionAns,
            'questionNo': this.unifiedRedemption.question,
            'item_type': this.unifiedRedemption.item_type,
            'tcm_id': this.unifiedRedemption.tcm_id,
            'userID': this._authenticationService.getUserID()
        };

        this._dataService.post('/auth/resumeISBNRedemption', body)
            .subscribe(
                (data: { data: any, response: string, response_message: Array<any> }) => {
                    if (data.response === 'success') {
                        // this.purchaseVerificationModalRef.close();
                        this._toastrService.typeCustomSuccess(data.response_message);
                    } else {
                        // this.purchaseVerificationModalRef.close();
                        this._toastrService.typeCustomError(data.response_message);
                    }
                    this._router.navigate(['home']);
                },
                (error) => {
                    this._toastrService.typeCustomError(error.error.response_message || error.status_text);
                    this._toastrService.dismissToastOnClick(error.error.response_message || error.status_text);
                    this._router.navigate(['home']);
                });
    }
}


// WEBPACK FOOTER //
// ./public/app/_services/landingpage.service.ts